import Http from '@/classes/http/Http'

export default {
  getAuditors () {
    return Http.get({
      url: 'auditors'
    })
  }
}
